<span class="userAccountIcon">
	<span class="accountIcon">
		<img
			*ngIf="!showDropdown"
			src="../../../../../assets/partner-assets/default-r6/icons/atom-icon-account-circle-black.svg"
		/>
		<img
			*ngIf="showDropdown"
			src="../../../../../assets/partner-assets/default-r6/icons/atom-icon-account-circle-blue.svg"
		/>
	</span>
	<div class="dropdownExpand" id="userAccountDropdown" *ngIf="showDropdown">
		<div class="changePasswordLabel">
			<a class="settingLabels">
				<span (click)="eventClicked('change-password')">CHANGE PASSWORD</span>
			</a>
		</div>
		<div class="logoutLabel">
			<a class="settingLabels">
				<app-breadcrumb-anchor label="LOG OUT" event="logout"></app-breadcrumb-anchor>
			</a>
		</div>
	</div>
</span>
